<template>
	<div :class="'BaseAlert BaseAlert--'+type">
        <slot></slot>
	</div>
</template>

<script>
export default {
	props: {
		type: {
			type: String,
			default: 'info'
		}
	}
}
</script>

<style lang="scss" scoped>
.BaseAlert {
	margin: 30px 0;
	background: #ffdedf;
	color: #c3383c;
	padding: 1em 1.5em;
	border-left: 6px solid #c3383c;
	font-weight: 600;
	font-size: 1.1em;

	&:first-child {
		margin-top: 0;
	}

	&--success {
		margin: 30px 0;
		background: rgb(240 255 221);
		color: rgb(133 195 56);
		padding: 1em 1.5em;
		border-left: 6px solid rgb(133 195 56);
		font-weight: 600;
		font-size: 1.1em;
	}

    ::v-deep(a) {
        color: inherit;
    }

    ::v-deep(small) {
        display: block;
        margin-top: .2em;
    }
}
</style>